/**
 * ConnectivityBanner — Sarabi OS · Banner globale stato rete.
 *
 * Renderizzato UNA volta a livello di layout persistente (`StaffShell` /
 * `AdminLayout`). Si sottoscrive a `useConnectivity()` e mostra:
 *   - offline → banner rosso persistente (sticky top).
 *   - syncing (post-recovery) → banner verde per 3s.
 *   - online e non syncing → NULL (nessun banner).
 *
 * Non blocca l'interfaccia sottostante; è puramente informativo.
 */
import React from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { useConnectivity } from "@/lib/connectivity";

export function ConnectivityBanner() {
  const { online, syncing } = useConnectivity();
  if (online && !syncing) return null;

  if (!online) {
    return (
      <div
        data-testid="connectivity-banner-offline"
        role="status"
        aria-live="polite"
        className="sticky top-0 z-40 w-full bg-rose-600 text-white px-4 py-2
                    flex items-center justify-center gap-2 text-sm font-medium
                    shadow-md">
        <WifiOff className="w-4 h-4" strokeWidth={2} />
        <span>Sarabi offline · i dati potrebbero non essere aggiornati</span>
      </div>
    );
  }

  // syncing (online da poco dopo offline / recovery lungo)
  return (
    <div
      data-testid="connectivity-banner-syncing"
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 w-full bg-emerald-600 text-white px-4 py-2
                  flex items-center justify-center gap-2 text-sm font-medium
                  shadow-md">
      <RefreshCw className="w-4 h-4 animate-spin" strokeWidth={2} />
      <span>Ricollegato · sincronizzazione in corso…</span>
    </div>
  );
}
